import { FC, useEffect, useMemo, useRef, useState } from 'react'
import {
  fetchData,
  formatDatePublic,
  formatNumber,
  getEncodedCookie,
  getEncryptedRoute,
  getTranslatedValue,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { Modal } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

export interface PropertyList {
  value: string | number
  en_name: string | number
  uz_name: string | number
  ru_name: string | number
  label: string
}
const ViewCancelledBookings: FC = () => {
  let t = Tr()
  const { menuIdEdit } = useMenuIdPermissions()
  const lang = useLang()
  const [cancelledList, setCancelledList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [selectedProperty, setSelectedProperty] = useState('') as any
  const [selectedCategory, setSelectedCategory] = useState('') as any
  const [propertyList, setPropertyList] = useState<{ value: string | number; label: string | number }[]>([])
  const [showInfo, setShowInfo] = useState(false)
  const handleCloseInfo = () => setShowInfo(false)
  const handleShowInfo = () => setShowInfo(true)
  const [cancellationPolicyInfo, setCancellationPolicyInfo] = useState('')
  const [apply, setApply] = useState('0') as any
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalRecords, setTotalRecords] = useState('') as any
  const [isInitialLoad, setIsInitialLoad] = useState(true)
  const [sortColumn, setSortColumn] = useState('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc')

  const [monthList] = useState([
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ]) as any

  const [categoryList] = useState([
    { value: '1', label: 'Accommodation' },
    { value: '4', label: 'Space Rental' },
    { value: '5', label: 'Tour Package' },
    { value: '7', label: 'Car Rental' },
  ]) as any

  const currentYear = new Date().getFullYear()
  const yearList = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  const [selectedMonth, setSelectedMonth] = useState('') as any
  const [selectedYear, setSelectedYear] = useState('') as any

  const getMonthStartAndEndDates = (year: number, month: number) => {
    if (!year || !month) {
      return {
        startDate: '',
        endDate: '',
      }
    }
    const startDate = new Date(year, month - 1, 1)
    const endDate = new Date(year, month, 0)

    // Format dates in 'YYYY-MM-DD' to avoid timezone-related issues
    const formattedStartDate = `${String(startDate.getDate()).padStart(2, '0')}-${String(
      startDate.getMonth() + 1
    ).padStart(2, '0')}-${startDate.getFullYear()}`
    const formattedEndDate = `${String(endDate.getDate()).padStart(2, '0')}-${String(
      endDate.getMonth() + 1
    ).padStart(2, '0')}-${endDate.getFullYear()}`

    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }
  }

  const clearFields = () => {
    setSelectedMonth('')
    setSelectedYear('')
    setSelectedProperty(null)
    setSelectedCategory('1')
    cancellationBookingListApiCall(1)
    setSortDirection('desc')
    setSortColumn('')
    setSearchTerm('')
  }
  const propertyListApiCall = async () => {
    let param: any = {
      categoryId: selectedCategory,
    }

    var response: any = await fetchData('admin/propertylist', param)

    if (response.status == '200') {
      let data = response.data
      let opt: { value: number | string; label: string | number }[] = [];
      data.map((val: PropertyList) => {
        opt.push({ value: val.value, label: getTranslatedValue(lang, val, "_name") })
      })

      setPropertyList(opt)
    } else {
      toasterrormsg(response.message)
    }
  }

  // date formatr change function

  const formatDate2 = (date: string): string => {
    const [year, month, day] = date.split('.')
    return `${day}-${month}-${year}`
  }

  //   hotel list api call
  const cancellationBookingListApiCall = async (isClear?: any) => {
    const { startDate, endDate } = getMonthStartAndEndDates(
      selectedYear != '' ? selectedYear : currentYear,
      selectedMonth
    )

    let param: any = {}

    if (isClear === 1) {
      // Initial load or clear: minimal params with default category
      param = {
        categoryId: categoryList[0].value, // Default to Accommodation
        limit: limit,
        offset: offset,
        sortOrder: sortDirection,
        field: sortColumn,
        searchText: searchTerm,
      }
    } else {
      // Normal call: use current filter states
      param = {
        categoryId: selectedCategory || categoryList[0].value, // Use selected or default
        fromDate: startDate || '', // Preserve selected date range
        toDate: endDate || '',
        actionId: selectedProperty || '', // Preserve selected property
        limit: limit,
        offset: offset,
        sortOrder: sortDirection,
        field: sortColumn,
        searchText: searchTerm,
      }
    }

    var res = await fetchData('admin/cancellationrecords', param)
    if (res.status == '200') {
      var data = res.data

      setCancelledList(data.data)
      setTotalRecords(data.totalRecord)
      setApply('0')
    } else {
      toasterrormsg(res.message)
      setApply('0')
    }
  }

  const sendRefundRequest = (bookingId: any, bookingdetailId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('To Send Refund Request'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'),
      cancelButtonText: t('Cancel'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          bookingId: bookingId,
          bookingdetailId: bookingdetailId,
        }

        var res = await fetchData('admin/changerefundstatus', param)

        if (res.status == '200') {
          toastsuccessmsg(res.message)
          cancellationBookingListApiCall()
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }

  // search hotel
  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)
  }

  const handleSort = (column: any, sortDirection: 'asc' | 'desc') => {
    setSortColumn(column.sortField)
    setSortDirection(sortDirection)
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Cancelled Booking')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }

  const getBookingRoute = () => {
    if (selectedCategory == '1') {
      const menuId = getEncodedCookie('accommodationBookingMenuId')
      return getEncryptedRoute('../viewhotelbookingdetails', { menuId: menuId })
    } else if (selectedCategory == '4') {
      const menuId = getEncodedCookie('spacerentalBookingMenuId')
      return getEncryptedRoute('../viewspacebookingdetails', { menuId: menuId })
    } else if (selectedCategory == '5') {
      const menuId = getEncodedCookie('tourBookingMenuId')
      return getEncryptedRoute('../viewtourbookingdetails', { menuId: menuId })
    } else if (selectedCategory == '7') {
      const menuId = getEncodedCookie('carBookingMenuId')
      return getEncryptedRoute('../viewcarbookingdetails', { menuId: menuId })
    }
    return '' // default fallback
  }

  const column: any = useMemo(
    () => [
      {
        name: t('Booking Id'),

        cell: (row: any) => (
          <div className='my-3'>
            <Link
              to={getBookingRoute()}
              state={{
                bookingId: row.bookingId,
              }}
            >
              <div className='fw-bold fs-5'>
                {row.bookingCode != '' ? '#' + row.bookingCode : ''}
              </div>
            </Link>
          </div>
        ),
        sortable: true,
        sortField: 'bookingCode',
        width: '150px',
      },

      {
        name: t('Booking Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <>
              {row.cancellationCharge != 'LastRecord' ? (
                <>
                  <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                    {t('Cancelled')}
                  </span>{' '}
                  <br />
                </>
              ) : (
                ''
              )}
              <div className='text-center mt-2'>
                <span className='fw-bold fs-6'>
                  {row.cancellationCharge == 'LastRecord'
                    ? ''
                    : row.cancellationCharge != ''
                      ? row.cancellationCharge + "% " + t('Charges')
                      : "0% " + t('Charges')}
                </span>
              </div>
            </>
          </div>
        ),
        sortable: true,
        width: '180px',
        sortField: 'cancellationCharge',
      },

      {
        name:
          selectedCategory == 1 || selectedCategory == ''
            ? t('Accommodation Name')
            : selectedCategory == 4
              ? t('Space Rental Name')
              : selectedCategory == 5
                ? t('Agency Name')
                : selectedCategory == 7
                  ? t('Supplier Name')
                  : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_actionName != '' ? row.en_actionName : '-'}</div>
          </div>
        ),
        sortable: true,
        sortField: 'en_actionName',
        width: '180px',
      },
      {
        name: t('Vendor Policy'),
        cell: (row: any) => (
          <div className='my-3'>
            <div
              className='fw-bold fs-5 text-primary cursor-pointer  text-decoration-underline'
              onClick={() => {
                setCancellationPolicyInfo(row.en_cancelpolicy)
                handleShowInfo()
              }}
            >
              {row.en_cancelpolicy != '' ? t('Cancellation Policy') : ''}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'en_cancelpolicy',
        width: '170px',
      },
      {
        name: t('Guest Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.guestName !== '' ? row.guestName : '-'}</div>
          </div>
        ),
        sortable: true,
        sortField: 'guestName',
        width: '170px',
      },
      {
        name:
          selectedCategory == 1 || selectedCategory == ''
            ? t('Room Name')
            : selectedCategory == 4
              ? t('Rentable Space Name')
              : selectedCategory == 5
                ? t('Tour Name')
                : selectedCategory == 7
                  ? t('Rentable Car Name')
                  : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.en_actiontypeName != '' ? row.en_actiontypeName : '-'}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'en_actiontypeName',
        width: '170px',
      },
      {
        name:
          selectedCategory == 1 || selectedCategory == ''
            ? t('Check In')
            : selectedCategory == 4
              ? t('Check In')
              : selectedCategory == 5
                ? t('Tour Date')
                : selectedCategory == 7
                  ? t('Pick Up Date')
                  : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.checkIn != '' ? formatDate2(row.checkIn) : '-'}</div>
          </div>
        ),
        sortable: true,
        sortField: 'checkIn',
        width: '170px',
      },
      {
        name: t('Cancellation Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.cancellationDate != '' ? formatDate2(row.cancellationDate) : '-'}
            </div>
          </div>
        ),
        sortable: true,
        width: '180px',
        sortField: 'cancellationDate',
      },
      {
        name:
          selectedCategory == 1 || selectedCategory == ''
            ? t('Days Before Check In')
            : selectedCategory == 4
              ? t('Days Before  Check In')
              : selectedCategory == 5
                ? t('Days Before Tour Date')
                : selectedCategory == 7
                  ? t('Days Before Renting')
                  : '',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.dayBeforeCheckIn != '' ? row.dayBeforeCheckIn : '-'}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'dayBeforeCheckIn',
        width: '170px',
      },

      {
        name: t('Cancellation Charge'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.cancellationCharge != 'LastRecord' && row.cancellationCharge != ''
                ? row.cancellationCharge + '%'
                : row.cancellationCharge == 'LastRecord'
                  ? '-'
                  : '0%'}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'cancellationCharge',
        width: '170px',
      },
      {
        name: t('Customer Refund'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.customerRefund != 'LastRecord' && row.customerRefund != ''
                ? row.customerRefund + '%'
                : row.customerRefund == 'LastRecord'
                  ? '-'
                  : '0%'}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'customerRefund',
        width: '170px',
      },
      {
        name: t('Total Paid'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount != '' &&
                row.totalAmount != undefined &&
                row.totalAmount != null &&
                row.totalAmount != 'LastRecord'
                ? formatNumber(parseFloat(row.totalAmount))
                : row.totalAmount == 'LastRecord'
                  ? '-'
                  : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        width: '170px',
        sortField: 'totalAmount',
      },
      {
        name: t('Refund Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.refundAmount != '' &&
                row.refundAmount != undefined &&
                row.refundAmount != null &&
                row.refundAmount != 'LastRecord'
                ? formatNumber(parseFloat(row.refundAmount))
                : row.refundAmount == 'LastRecord'
                  ? '-'
                  : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'refundAmount',
        width: '170px',
      },
      {
        name: t('Final Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.finalAmount != '' ? formatNumber(parseFloat(row.finalAmount)) : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'finalAmount',
        width: '170px',
      },
      {
        name: t('Insayr Service Fee'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.insayrRevenue != '' &&
                row.insayrRevenue != null &&
                row.insayrRevenue != undefined
                ? formatNumber(parseFloat(row.insayrRevenue))
                : '0 UZS'}
            </div>
          </div>
        ),
        sortable: true,
        sortField: 'insayrRevenue',
        width: '170px',
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              <div className='fw-bold fs-5'>
                {row.refundStatus != 'LastRecord' ? (
                  row.isRefunded == true ? (
                    <span
                      className='btn fw-bold p-1 btn-sm btn-success mx-2 '
                      style={{ width: '100px' }}
                    >
                      {t('Submitted')}
                    </span>
                  ) : (
                    <>
                      {menuIdEdit ? (
                        <span
                          className='btn fw-bold p-1 btn-sm btn-light-danger mx-2 cursor-pointer'
                          style={{ width: '100px' }}
                          onClick={(e) => {
                            sendRefundRequest(row.bookingId, row.bookingdetailId)
                          }}
                        >
                          {t('Refund Now')}
                        </span>
                      ) : (
                        ''
                      )}
                    </>
                  )
                ) : (
                  '-'
                )}
              </div>
            </div>
          </div>
        ),
        sortable: false,
        width: '170px',
      },
      {
        name: t('Refund Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.processDate != 'LastRecord' && row.processDate != '' && row.processDate
                ? formatDatePublic(row.processDate)
                : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.processDate),
        width: '190px',
        sortField: 'processDate',
      },
      {
        name: t('Refund Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              <div className='fw-bold fs-5'>
                {row.refundStatus != 'LastRecord' ? (
                  <>
                    {row.paymentStatus == 'PAID' ? (
                      <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                        {t('Paid')}
                      </span>
                    ) : row.paymentStatus == 'HOLD' ? (
                      <span
                        className='btn text-white mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'
                        style={{ backgroundColor: 'orange' }}
                      > 
                        {t('Hold')}
                      </span>
                    ) : row.paymentStatus == 'REVERSED' ? (
                      <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                        {t('Reversed')}
                      </span>
                    ) : row.paymentStatus == 'PENDING' ? (
                      <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                        {t('Pending')}
                      </span>
                    ) : row.paymentStatus == 'CANCELLED' || row.paymentStatus == 'FAILED' ? (
                      <>
                        <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                          {row.paymentStatus == 'CANCELLED' ? t('Cancelled') : t('Failed')}
                        </span>
                      </>
                    ) : row.paymentStatus == 'REFUNDED'  ? (
                      <>
                        <span className='btn btn-secondary mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>
                          {t('Refunded')}
                        </span>
                      </>
                    )
                      : (
                        <span className='fw-bold'>N/A</span>
                      )}

                  </>) : (
                  '-'
                )}
              </div>
            </div>
          </div>
        ),
        sortable: false,
        width: '170px',
      },
    ],
    [apply == 1, t]
  )

  useEffect(() => {
    // Only run this on initial mount
    if (isInitialLoad) {
      cancellationBookingListApiCall(1) // Initial load with default category "1"
      setSelectedCategory(categoryList[0].value) // Set default category
      setIsInitialLoad(false) // Mark initial load as complete
      document.title = 'Insayr | View Cancelled Bookings'
    }
  }, []) // Empty dependency array for initial load only

  useEffect(() => {
    // This runs only when limit or offset changes, not on initial load
    if (!isInitialLoad) {
      cancellationBookingListApiCall() // Call API with current filters, no reset
    }
  }, [limit, offset, sortColumn, sortDirection, searchTerm]) // Trigger on pagination changes

  useEffect(() => {
    if (selectedCategory != '' && selectedCategory != null && selectedCategory != undefined) {
      propertyListApiCall()
    }
  }, [selectedCategory])

  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit)

    // if (newPage > currentPage) {
    //   setOffset(offset + limit)
    // } else {

    //   setOffset(offset - limit)
    // }
    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }
  return (
    <>
      <ToastContainer />

      <div className='container'>
        <div className='justify-content-center d-flex flex-wrap gap-5 mb-6'>
          <div className='filters'>
            <label htmlFor='selectCategory' className='fs-4 form-label'>
              {t('Select Category')}
            </label>
            <Select
              name='selectCategory'
              id='selectCategory'
              placeholder={t('Select Category')}
              isSearchable={true}
              options={categoryList}
              value={categoryList.find((option: any) => option.value == selectedCategory) || null}
              onChange={(e: any) => {
                setSelectedCategory(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              {t('Select Month')}
            </label>
            <Select
              name='selectFromDate'
              id='selectFromDate'
              placeholder={t('Select Month')}
              isSearchable={true}
              options={monthList}
              value={monthList.find((option: any) => option.value == selectedMonth) || null}
              onChange={(e: any) => {
                setSelectedMonth(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='fromDate' className='fs-4 form-label'>
              {t('Select Year')}
            </label>
            <Select
              name='selectVendorYear'
              id='selectVendorYear'
              placeholder={t('Select Year')}
              isSearchable={true}
              options={yearList}
              value={yearList.find((option: any) => option.value == selectedYear) || null}
              onChange={(e: any) => {
                setSelectedYear(e.value)
              }}
            />
          </div>
          <div className='filters'>
            <label htmlFor='selectProperty' className='fs-4 form-label'>
              {t('Select Property')}
            </label>
            <Select
              name='selectProperty'
              id='selectProperty'
              placeholder={t('Select Property')}
              isSearchable={true}
              options={propertyList}
              value={propertyList.find((option: any) => option.value == selectedProperty) || null}
              onChange={(e: any) => setSelectedProperty(e.value)}
              styles={{
                container: (provided) => ({ ...provided, width: '100%' }),
                control: (provided) => ({ ...provided, minHeight: 43 }),
              }}
            />
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-center mb-5'>
        <div className='col-md-2 mb-3 d-flex align-items-end'>
          <button
            className='btn btn-primary mx-1'
            onClick={() => {
              cancellationBookingListApiCall()
              setApply('1')
            }}
          >
            {t('Apply')}
          </button>
          <button className='btn btn-danger mx-1' onClick={() => clearFields()}>
            {t('Clear')}
          </button>
        </div>
      </div>

      <DataTable
        columns={column}
        data={cancelledList}
        pagination
        paginationServer={true}
        onChangePage={handlePageChange}
        paginationTotalRows={totalRecords}
        paginationPerPage={limit}
        onChangeRowsPerPage={handleRowsPerPageChange}
        paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
        subHeader={true}
        subHeaderComponent={<CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />}
        onSort={handleSort}
        paginationComponentOptions={{
          rowsPerPageText: t('Rows Per Page'),
        }}
        sortServer
      />

      <Modal show={showInfo} onHide={handleCloseInfo} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          id='kt_modal_upload'
          tabIndex={-1}
          style={{ display: 'block' }}
          aria-modal='true'
          role='dialog'
        >
          <div className='modal-dialog modal-dialog-centered mw-700px'>
            <div className='modal-content'>
              <div className='form' id='kt_modal_upload_form'>
                <div className='modal-header d-flex justify-content-between border-bottom border-1 border-success'>
                  <h2 className='fw-bold'>{t('Cancellation Policy')}</h2>

                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleCloseInfo}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>

                <div className='modal-body pt-10 pb-15 px-lg-17'>
                  {cancellationPolicyInfo != '' ? (
                    <div dangerouslySetInnerHTML={{ __html: cancellationPolicyInfo }}></div>
                  ) : (
                    <div className='text-center fw-bold fs-3'>{t('No Data Found')}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export { ViewCancelledBookings }
